module.exports = __webpack_public_path__ + "img/menu.799ec213.svg";